import { Navigate } from "react-router-dom";
import Cookies from "js-cookie";
import { ReactNode } from "react";

export const PermissionRoute: React.FC<{ children: ReactNode, requiredPermission: string }> = ({ children, requiredPermission }) => {

  if (!Cookies.get("user_permission").split("-").includes(requiredPermission)) {
    return <Navigate to="/restricted" replace />;
  }

  return <>{children}</>
};
